import React from 'react';

function Navbar (){
    return(
        <div >
           <nav className="navbar">
              <h1 className='nav-heading'>Top Courses</h1>
           </nav>
        </div>
    );
};

export default Navbar;